'use strict';
document.querySelectorAll('form input').forEach(function(input) {
    var label = document.createElement('label');
    label.classList.add('field-label');
    label.htmlFor = input.id;
    var formattedName = input.name[0].toUpperCase() + input.name.slice(1);
    label.textContent = formattedName;
    input.placeholder = formattedName;
    var parentElem = input.parentElement;
    parentElem.append(label);
});

//# sourceMappingURL=js_task_fix_form_DOM.5d6abefe.js.map
